export const m4l4Solution = `%lang starknet
from starkware.cairo.common.alloc import alloc

// Arrays can also contain structs

struct Point {
    x : felt,
    y : felt,
    z : felt,
}
// do not modify code on this line or above

// TODO fix the contains_origin function to pass the tests
func contains_origin{range_check_ptr : felt}(len_points : felt, points : Point*) -> (bool : felt) {
    // FILL ME
    if (len_points == 0) {
        return (bool=0);
    }
    if (points[0].x != 0) {
        return contains_origin(len_points-1, points + Point.SIZE);
    }
    if (points[0].y != 0) {
        return contains_origin(len_points-1, points + Point.SIZE);
    }
    if (points[0].z != 0) {
        return contains_origin(len_points-1, points + Point.SIZE);
    }
    
    return (bool=1);
}

// do not modify code on this line or below

@external
func test_contains_origin{range_check_ptr : felt}() {
    alloc_locals;

    let (local false_array : Point*) = alloc();
    assert false_array[0] = Point(1, 2, 3);
    assert false_array[1] = Point(2, 2, 2);
    assert false_array[2] = Point(42, 27, 11);

    let (res) = contains_origin(3, false_array);
    assert res = 0;

    let (local true_array : Point*) = alloc();
    assert true_array[0] = Point(1, 2, 3);
    assert true_array[1] = Point(0, 0, 0);
    assert true_array[2] = Point(42, 27, 11);

    let (res) = contains_origin(3, true_array);
    assert res = 1;

    return ();
}`;
